import React, { useRef } from 'react';
import { useBattle } from '../context/BattleProvider';
// import { BackingTrackSource } from '../../interfaces/battleInterfaces';
import { useUser } from '../hooks/useUser';

// Shows the host controls for uploading / selecting a backing track and playing it.
// Displayed only in the host view.

export const BackingTrackPanel: React.FC = () => {
  const { backingTrack, setBackingTrack, isPlayingTrack, playBackingTrack, stopBackingTrack } =
    useBattle();
  const { user } = useUser();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBackingTrack({ type: 'file', file });
  };

  const handleLibrarySelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = user?.songs?.find((s) => s.song_id === Number(e.target.value));
    if (!selected) return;
    setBackingTrack({ type: 'library', url: selected.media, title: selected.title });
  };

  const trackLabel = backingTrack
    ? backingTrack.type === 'file'
      ? backingTrack.file.name
      : backingTrack.title
    : 'No track selected';

  return (
    <div
      style={{
        background: 'var(--bg-raised)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-lg)',
        padding: '14px 16px',
      }}
    >
      <p className="section-label">Backing track</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 }}>
        {/* Library picker */}
        {user?.songs && user.songs.length > 0 && (
          <select onChange={handleLibrarySelect} defaultValue="" style={{ fontSize: 13 }}>
            <option value="" disabled>
              Pick from your library…
            </option>
            {user.songs.map((s) => (
              <option key={s.song_id} value={s.song_id}>
                {s.title}
              </option>
            ))}
          </select>
        )}

        {/* File upload */}
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button
            className="btn-ghost"
            style={{ fontSize: 12, padding: '6px 12px', flexShrink: 0 }}
            onClick={() => fileInputRef.current?.click()}
          >
            Upload file
          </button>
          <span
            style={{
              fontSize: 12,
              color: 'var(--text-muted)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {trackLabel}
          </span>
          <input
            ref={fileInputRef}
            type="file"
            accept="audio/*"
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </div>

        {/* Play / stop */}
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            className="btn-primary"
            style={{ fontSize: 13, padding: '8px 16px' }}
            onClick={playBackingTrack}
            disabled={!backingTrack || isPlayingTrack}
          >
            {isPlayingTrack ? 'Playing…' : 'Play track'}
          </button>
          {isPlayingTrack && (
            <button
              className="btn-ghost"
              style={{ fontSize: 13, padding: '8px 16px' }}
              onClick={stopBackingTrack}
            >
              Stop
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
